const Pillar = ({ position, color }) => {
  return (
    <span
      style={{
        backgroundColor: color ? color : "#3399ff",
        height: "32px",
        width: "5px",
        position: "absolute",
        left: "7px",
        ...(position === "upper" ? { top: "-32px" } : { bottom: "-32px" }),
      }}
    ></span>
  );
};

export default Pillar;
